import React from 'react';
import {useLang,getUserBadges} from './i18n';
import {StaffMark} from './StaffMark';
import {UserVerifiedMark} from './UserVerifiedMark';
import {BadgeToken} from './BadgeToken';
import {HoverTip} from './HoverTip';

/** Compact public badges only. Hidden team badges are already omitted by the server. */
export function ChannelBadges({person}:{person:any}) {
  const [lang,,tr]=useLang();
  const items:{id:string;label:string;node:React.ReactNode}[]=[];
  for(const [field,label] of [['staff',tr('MALVO Team','MALVO-Team')],['malvoDeveloper','MALVO Developer'],['malvoModerator','MALVO Moderator']]) {
    if(person?.[field])items.push({id:field,label,node:<StaffMark person={{[field]:true}} size={14}/>});
  }
  if(person?.accountVerified&&!person?.bot&&!person?.username?.startsWith('deleted_'))items.push({id:'verified',label:tr('Verified by MALVO','Von MALVO verifiziert'),node:<UserVerifiedMark person={person}/>});
  for(const badge of getUserBadges(person))items.push({id:badge.id,label:lang==='de'?badge.labelDe:badge.label,node:<BadgeToken badge={badge} lang={lang}/>});
  if(!items.length)return null;
  const rest=items.slice(3);
  return <span className="voice-roster-badges" aria-label={tr('Profile badges','Profilabzeichen')}>
    {items.slice(0,3).map(item=><span className="voice-roster-badge" key={item.id}>{item.node}</span>)}
    {!!rest.length&&<HoverTip wrap className="voice-roster-badge-more" label={rest.map(item=>item.label).join(' · ')}>+{rest.length}</HoverTip>}
  </span>;
}
